import { observer } from 'mobx-react-lite'
import { getAriaLabel } from 'shared/lib'
import { Box } from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { SelectNumbers } from 'pages/settings/pages/compliance/ui/MultiSelectNumbers/SelectNumbers'

import { type CommonNumbersStore } from 'pages/settings/pages/compliance/ui/CommonNumbers/store/commonNumbersStore'
import styles from './styles.module.scss'

type ICommonNumbersProps = {
  loading: boolean
  numbersStore: CommonNumbersStore
  isLabelQuestionTooltip?: boolean
  labelText?: string
}

export const CommonNumbers = observer(
  ({
    loading,
    numbersStore,
    isLabelQuestionTooltip = true,
    labelText = 'Phone numbers',
  }: ICommonNumbersProps) => {
    const {
      multiSelectedKeys,
      search,
      setSearch,
      numbersGroups,
      setMultipleItem,
      handleMultiSelect,
      isDeselectState,
      multiSelectedValues,
      handleMultiDeselect,
      removeMultiSelectedItem,
    } = numbersStore

    return (
      <Box
        display='grid'
        gap='4px'
        marginTop='42px'
        aria-label={getAriaLabel('SelectUnverifedTollFreeNumbers')}
        minWidth={492}
      >
        <Label
          label={{
            text: labelText,
          }}
          questionTooltipProps={
            isLabelQuestionTooltip
              ? {
                  label: (
                    <>
                      <span className={styles.labelText}>Select all your Salesmsg numbers</span>
                      {' that you want to add to this Caller ID'}
                    </>
                  ),
                  width: '240px',
                }
              : undefined
          }
        />
        <SelectNumbers
          multiSelectedKeys={multiSelectedKeys}
          search={search}
          setSearch={setSearch}
          numbersGroups={numbersGroups}
          isLoading={loading}
          setMultipleItem={setMultipleItem}
          handleMultiSelect={handleMultiSelect}
          isDeselectState={isDeselectState}
          multiSelectedValues={multiSelectedValues}
          handleMultiDeselect={handleMultiDeselect}
          removeMultiSelectedItem={removeMultiSelectedItem}
        />
      </Box>
    )
  }
)
